export default __webpack_public_path__ + "static/zasady-ochrany-osobnich-udaju-d1bd9090d607e63908ce0b4d0fdc7ff8.pdf";